<template>
  <div class="modal is-active">
    <div class="popup-background" @click="onClose"></div>
    <div class="message-cart" style="height: auto">
      <h2>{{ title }}</h2>
      <div class="upper" :class="noFlex">
        <slot></slot>
      </div>
      <h3 v-if="msg !== undefined">{{ msg }}</h3>
      <button
        @click="onClose"
        class="button icon is-primary is-small close-message-cart"
        style="font-size: 30px"
      ></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    title: {
      type: String,
      required: true,
    },
    msg: {
      type: String,
      required: false,
    },
    noFlex: {
      type: String,
      required: false,
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
  },
}
</script>
